import { useId, useState, type InputHTMLAttributes } from "react";

interface PasswordInputFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  error?: string;
}

export default function PasswordInputField({ label, error, className = "", id, ...props }: PasswordInputFieldProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <label htmlFor={inputId} className="mb-2 block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="relative">
        <input
          {...props}
          id={inputId}
          type={visible ? "text" : "password"}
          aria-invalid={error ? "true" : "false"}
          className={`${className} pr-12`}
        />
        <button
          type="button"
          onClick={() => setVisible((current) => !current)}
          className="absolute inset-y-0 right-0 flex w-12 items-center justify-center text-gray-400 transition hover:text-gray-600"
          aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        >
          <i className={visible ? "ri-eye-off-line text-lg" : "ri-eye-line text-lg"}></i>
        </button>
      </div>
      {error ? <p className="mt-2 text-sm text-red-600">{error}</p> : null}
    </div>
  );
}
